// @ts-nocheck
import React from 'react';
import styled from 'styled-components';

import CheckNew from 'crehana-icons/CheckNew';
import Minus from 'crehana-icons/Minus';
import { white, yellowMain, secondaryDark } from 'crehana-ui/styles/colors';

import { ChecksProps } from '../types';

const CustomCol = styled.div<{ isOpen: boolean }>`
  transition: 0.5s;
  transform: ${props => (props.isOpen ? 'translateY(75%)' : 'translateY(0)')};
`;

const renderAccessPlan = ({
  hasAccess,
  isHighlighted,
}: {
  hasAccess: boolean | string;
  isHighlighted: boolean;
}) => {
  if (hasAccess) {
    return typeof hasAccess === 'string' ? (
      <span
        className={`${
          isHighlighted ? 'text-yellow-main' : 'text-white'
        } font-body3`}
      >
        {hasAccess}
      </span>
    ) : (
      <span>
        <CheckNew size={24} color={isHighlighted ? yellowMain : white} />
      </span>
    );
  }
  return <Minus size={16} color={secondaryDark} />;
};

const Checks: React.FC<ChecksProps> = ({
  benefit: {
    FREE_PLAN: freePlan,
    PREMIUM: individualPlan,
    PREMIUM_DUO: duoPlan,
    FAMILIAR: familyPlan,
  },
  isOpen,
}) => {
  return (
    <CustomCol isOpen={isOpen} className="w-8/12 flex justify-around ">
      <p className="text-center w-2/12">
        {freePlan?.hasAccess ? (
          <CheckNew
            size={24}
            color={freePlan.isHighlighted ? yellowMain : white}
          />
        ) : (
          <Minus size={16} color={secondaryDark} />
        )}
      </p>

      <p className="text-center w-2/12">
        {individualPlan?.hasAccess ? (
          <span>
            <CheckNew
              size={24}
              color={individualPlan.isHighlighted ? yellowMain : white}
            />
          </span>
        ) : (
          <Minus size={16} color={secondaryDark} />
        )}
      </p>

      {duoPlan && (
        <p className="text-center w-2/12">{renderAccessPlan(duoPlan)}</p>
      )}

      {familyPlan && (
        <p className="text-center w-2/12">{renderAccessPlan(familyPlan)}</p>
      )}
    </CustomCol>
  );
};

export default Checks;
